
import { Component, Prop, Vue } from "vue-property-decorator";
import { mobileRules } from "@common/src/utils/verify";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
const common_base = namespace("common_base");

@InjectFunction("emptyToLine")
@Component({
  model: {
    prop: "selectedList",
    event: "change"
  }
})
export default class Template extends Vue {
  @common_base.Action queryCustomerInfoList;
  @Prop({ type: Array, default: () => [] })
  selectedList: any;
  @Prop({ type: Boolean, default: true })
  mobilePassed: any;
  @Prop({ type: String, default: "" })
  warningText: any;
  invalidNum: number = 0;
  showDialog: boolean = false;
  get invalidList() {
    const arr = this.selectedList.filter((item, index) => {
      if (mobileRules(item.mobile).success) {
        return false;
      } else {
        this.invalidCodeMap[item.customerCode] = index;
        return true;
      }
    });
    if (this.selectedList && this.selectedList.length) {
      if (arr.length > 0) {
        this.$emit("update:mobilePassed", false);
      } else {
        this.$emit("update:mobilePassed", true);
      }
    }
    return arr;
  }
  invalidCodeMap: any = {};
  handleRemoveInvalid() {
    const list = this.selectedList.filter(item => {
      return mobileRules(item.mobile).success;
    });
    this.$emit("change", list);
  }
  handleShowInvalidList() {
    this.showDialog = true;
  }
  handleCustomerRefresh() {
    this.$emit("refresh");
    const codes = this.invalidList.map(item => item.customerCode);
    this.queryCustomerInfoList({ customerCodes: codes }).then(data => {
      this.$safeValue(data, "data.list", []).forEach(item => {
        this.selectedList[this.invalidCodeMap[item.customerCode]].mobile = item.customerMobile;
      });
      this.$emit("change", this.selectedList);
    });
  }
  handleGoEditCustomer(row) {
    const { href } = this.$router.resolve(`/setting/customer-edit/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
    window.open(href);
  }
}
